import {
  Button,
  MenuButton,
  MenuButtonProps as ChakraMenuButtonProps,
} from '@chakra-ui/react'
import React from 'react'

const menuButtonStyles = {
  default: {
    bg: 'white',
    borderColor: 'gray.500',
    _hover: {
      bg: 'gray.100',
    },
    _active: {
      bg: 'white',
    },
  },
}

interface DropdownButtonProps extends ChakraMenuButtonProps {
  children: React.ReactElement | string
  rightIcon?: React.ReactElement
  leftIcon?: React.ReactElement
}

const DropdownButton = (props: DropdownButtonProps) => {
  const { leftIcon, rightIcon, children, ...otherProps } = props

  return (
    <MenuButton
      {...menuButtonStyles.default}
      as={Button}
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      {...otherProps}
    >
      {children}
    </MenuButton>
  )
}

export default DropdownButton
